var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"text-h5"},[_vm._t("title")],2),_c('v-card-text',[_c('div',{staticClass:"my-5"},[_vm._t("body")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }